import moment from 'moment-timezone';

export const getTimeZonedDate = (timeZone, date) => {
  const timeZoneOffset = moment.tz(timeZone).utcOffset();
  const tzDifference = timeZoneOffset + date.getTimezoneOffset();
  return new Date(date.getTime() - tzDifference * 60 * 1000);
};

export const dateFieldsAreValid = (broadcast, startDateTime, endDateTime) => {
  if (broadcast) {
    return (startDateTime && !endDateTime) || (!startDateTime && endDateTime);
  } else {
    return !(startDateTime && endDateTime);
  }
};

export const handleFilterTime = (time, minEndDate, maxEndDate, endDateTime) => {
  const selectedDate = new Date(time);
  const minDate = new Date(minEndDate);
  if (!endDateTime) {
    selectedDate.setDate(minDate.getDate());
    selectedDate.setMonth(minDate.getMonth());
  }
  const maxDate = new Date(maxEndDate);
  const selectedDateInMin = Math.floor(selectedDate.getTime() / 60000);
  const minDateInMin = Math.floor(minDate.getTime() / 60000);
  const maxDateInMin = Math.floor(maxDate.getTime() / 60000);

  if (selectedDate.getDate() === minDate.getDate()) {
    return minDateInMin <= selectedDateInMin;
  }

  return maxDateInMin >= selectedDateInMin;
};

export const calculateDuration = (startDate, endDate) => {
  const oneDayInMs = 86400000;
  const oneHourInMs = 3600000;
  const oneMinInMs = 60000;
  const diffMs = endDate - startDate;
  const diffDays = Math.floor(diffMs / oneDayInMs);
  let diffHrs = Math.floor((diffMs % oneDayInMs) / oneHourInMs);
  const diffMins = Math.round(
    ((diffMs % oneDayInMs) % oneHourInMs) / oneMinInMs,
  );

  if (diffDays) diffHrs += 24 * diffDays;

  let durationText;

  const hourText = diffHrs > 1 ? 'hours' : 'hour';

  if (diffHrs < 0 || diffMins < 0) durationText = `--:--`;
  else if (!diffHrs && !diffMins) durationText = `--:--`;
  else {
    if (diffHrs) {
      if (diffMins) durationText = `${diffHrs} ${hourText} ${diffMins} minutes`;
      else durationText = `${diffHrs} ${hourText}`;
    } else durationText = `${diffMins} minutes`;
  }

  return durationText;
};

export const getRoundedDate = (minutes, date) => {
  const ms = 1000 * 60 * minutes; // convert minutes to ms
  return new Date(Math.ceil(date.getTime() / ms) * ms);
};
